import { render } from "./WidgetAnwendungsListe.vue?vue&type=template&id=f63bb71c&scoped=true&ts=true"
import script from "./WidgetAnwendungsListe.vue?vue&type=script&lang=ts"
export * from "./WidgetAnwendungsListe.vue?vue&type=script&lang=ts"

import "./WidgetAnwendungsListe.vue?vue&type=style&index=0&id=f63bb71c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63bb71c"]])

export default __exports__